import { createContext, useContext } from 'react';

const VoucherContext = createContext(null);

export const useVoucherContext = () => useContext(VoucherContext);

export default VoucherContext;
